<div [class]="'gradiented-background '  +(codeEnabled? 'code':'no-code')">
  <div class="choose-container" [ngClass]="{'open-code': codeOpen && codeEnabled}" (click)="chooseClicked.emit()"><ng-content></ng-content></div>
  <div class="code-container" [ngClass]="{'open-code': codeOpen && codeEnabled}"><ng-content select="[sm-code]"></ng-content></div>
</div>
